import Skeleton from "@material-ui/lab/Skeleton";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { MainCard } from "../../components";
import MainWheel from "../../components/Gallery/MainWheel";
import wheelTypes from "../../constants/wheelTypes";
import { toast } from "react-toastify";
import {
  getUserClonedWheelsAction,
  getUserPrimaryWheelAction,
  getUserPrivateWheelsAction,
  getUserPublicWheelsAction,
  makeWheelPrimaryAction,
  makeWheelPrivateAction,
  makeWheelPublicAction,
  removeUserWheelAction,
} from "../../redux/actions/wheels";
import {
  useDeleteWheel,
  useUpdatePrimaryWheel,
  useUpdateWheelVisibility,
} from "../../services/mutations";
import { ASSETS } from "../../utils/config";
import { getLoggedInUser } from "../../utils/helpers";

const WheelsSection = ({
  publicRef,
  privateRef,
  clonesRef,
  unlockRef,
  setOpenWheelPopup,
}) => {
  const [searchedText, setSearchedText] = useState("");
  const [searchedWheels, setSearchedWheels] = useState([]);
  const [mainWheel, setMainWheel] = useState(null);
  const { userid } = useParams();

  const dispatch = useDispatch();

  const { userWheels, loading: wheelListLoading } = useSelector(
    (state) => state.userWheels
  );

  const {
    userPublicWheels = [],
    userPrivateWheels = [],
    userClonedWheels = [],
    userPrimaryWheel,
    loading: {
      public: publicLoading,
      private: privateLoading,
      cloned: clonedLoading,
    },
  } = useSelector((state) => ({
    userPublicWheels: state.userWheels.userPublicWheels || [],
    userPrivateWheels: state.userWheels.userPrivateWheels || [],
    userClonedWheels: state.userWheels.userClonedWheels || [],
    userPrimaryWheel: state.userWheels.userPrimaryWheel,
    loading: state.userWheels.loading,
  }));

  const [searchedPublicWheels, setSearchedPublicWheels] = useState([]);
  const [searchedPrivateWheels, setSearchedPrivateWheels] = useState([]);
  const [searchedClonedWheels, setSearchedClonedWheels] = useState([]);
  const [searchedPrimaryWheel, setSearchedPrimaryWheel] = useState(null);

  const handleSearch = (event) => {
    const newValue = event.target.value;
    setSearchedText(newValue);
  };

  useEffect(() => {
    var id = userid || getLoggedInUser()?.id;
    dispatch(getUserClonedWheelsAction(id));
    dispatch(getUserPublicWheelsAction(id));
    dispatch(getUserPrivateWheelsAction(id));
    dispatch(getUserPrimaryWheelAction(id));
  }, []);

  useEffect(() => {
    if (searchedText) {
      const filteredPublicWheels = userPublicWheels.filter((wheel) =>
        wheel?.wheel_name.toLowerCase().includes(searchedText)
      );

      const filteredPrivateWheels = userPrivateWheels.filter((wheel) =>
        wheel?.wheel_name.toLowerCase().includes(searchedText)
      );

      const filteredClonedWheels = userClonedWheels.filter((wheel) =>
        wheel?.wheel_name.toLowerCase().includes(searchedText)
      );

      const filteredPrimaryWheel =
        userPrimaryWheel &&
        userPrimaryWheel?.wheel_name.toLowerCase().includes(searchedText)
          ? userPrimaryWheel
          : null;

      setSearchedPublicWheels(filteredPublicWheels);
      setSearchedPrivateWheels(filteredPrivateWheels);
      setSearchedClonedWheels(filteredClonedWheels);
      setSearchedPrimaryWheel(filteredPrimaryWheel);
      setSearchedWheels([
        ...filteredPublicWheels,
        ...filteredPrivateWheels,
        ...filteredClonedWheels,
        ...(filteredPrimaryWheel ? [filteredPrimaryWheel] : []),
      ]);
    }
  }, [searchedText]);

  const [isLoadingWheel, setIsLoadingWheel] = useState(false);

  const deleteSelectdeWheel = useDeleteWheel();

  const onDeleteWheelPress = (wheelType, wheelId) => {
    let text = "Do you want to delete the selected Wheel?";
    if (window.confirm(text) === true) {
      setIsLoadingWheel(wheelId);
      deleteSelectdeWheel.mutate(
        { wheelID: wheelId },
        {
          onSuccess: (response) => {
            dispatch(removeUserWheelAction({ wheelId, wheelType }));
            setIsLoadingWheel(null);
            if (response?.status === 204) {
              toast.success("Wheel deleted successfully.");
            }
            // setUserWheelList(null);
          },
          onError: (error) => {
            setIsLoadingWheel(null);
            console.log("deleteWheel error: ", error);
          },
        }
      );
    }
  };

  const updatePrimaryWheel = useUpdatePrimaryWheel();

  const onMakePrimaryPress = (wheelId, wheelObj, wheelType) => {
    setIsLoadingWheel(wheelId);

    updatePrimaryWheel.mutate(wheelId, {
      onSuccess: (response) => {
        setIsLoadingWheel(null);

        if (response?.status === 200) {
          dispatch(makeWheelPrimaryAction(wheelObj));
        }
      },
      onError: (error) => {
        setIsLoadingWheel(null);
      },
    });
  };

  const updateVisibility = useUpdateWheelVisibility();

  const onMakePublicPrivatePress = (wheelId, wheelObj, wheelType) => {
    setIsLoadingWheel(wheelId);

    updateVisibility.mutate(wheelId, {
      onSuccess: (response) => {
        setIsLoadingWheel(null);
        if (response?.status === 200) {
          if (response?.data?.is_public === true) {
            dispatch(makeWheelPublicAction(wheelId));
          } else {
            dispatch(makeWheelPrivateAction(wheelId));
          }
        }
      },
      onError: (error) => {
        setIsLoadingWheel(null);
      },
    });
  };

  const renderNoWheelsFound = () => {
    return (
      <div
        style={{
          width: "50vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          margin: "10vh auto",
          marginTop: "10vh",
        }}
      >
        {searchedText ? (
          <>
            <img
              src={ASSETS.noBusinessbox}
              alt="empty"
              style={{
                width: "30%",
              }}
            />
            <h4 style={{ marginTop: "2vh" }}>No wheels found!</h4>
          </>
        ) : (
          <>
            <h4 style={{ marginBottom: "2vh" }}>
              Oops! You haven't created any wheels yet.
            </h4>
            <div
              style={{ width: "30%" }}
              role="button"
              onClick={() => {
                setOpenWheelPopup(true);
              }}
            >
              <img
                src={ASSETS.createwheel}
                alt="Create wheel"
                className="img-fluid w-100"
              />
              <div className="text-center" style={{ fontSize: 20 }}>
                Create iYuga <br />
                Wheel
              </div>
            </div>{" "}
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {(publicLoading || privateLoading || clonedLoading) &&
      !userPrimaryWheel &&
      !userPrivateWheels.length &&
      !userPublicWheels.length &&
      !userClonedWheels.length ? (
        <Skeleton
          variant="rect"
          width={"100%"}
          height={"78vh"}
          style={{ borderRadius: "20px" }}
        />
      ) : (
        <>
          <div>
            <TextField
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "rgba(18, 48, 81, 0.5)",
                  },
                },
              }}
              label=""
              value={searchedText}
              variant="outlined"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                style: {
                  border: "0.2px solid #E1E1E1",
                  borderRadius: "60px",
                  backgroundColor: "white",
                },
              }}
            />
          </div>

          {(searchedText && searchedWheels?.length == 0) ||
          (userWheels?.length == 0 && !wheelListLoading) ? (
            renderNoWheelsFound()
          ) : (
            <>
          
               {!!userPrimaryWheel &&  <MainWheel
                  onMakePrivatePress={onMakePublicPrivatePress}
                  deletingWheelId={isLoadingWheel}
                  wheelType={wheelTypes.main}
                  onDeleteWheelPress={onDeleteWheelPress}
                  mainName={userPrimaryWheel?.wheel_name || "Wheel Name"}
                  authorName={mainWheel?.user_profile?.first_name}
                  data={
                    searchedText.length
                      ? searchedPrimaryWheel
                      : userPrimaryWheel
                  }
                />}
          

              {userPublicWheels?.length ? (
                <div ref={publicRef}>
                  <MainCard
                    isLoading={publicLoading}
                    onMakePrivatePress={onMakePublicPrivatePress}
                    deletingWheelId={isLoadingWheel}
                    wheelType={wheelTypes.public}
                    wheels={
                      searchedText.length
                        ? searchedPublicWheels
                        : userPublicWheels
                    }
                    mainImg={ASSETS.publicDark}
                    name={`Public`}
                    cardTitle={`Wheels`}
                    onDeleteWheelPress={onDeleteWheelPress}
                    isPublic={true}
                    onMakePrimaryPress={onMakePrimaryPress}
                    onMakePublicPrivatePress={onMakePublicPrivatePress}
                  />
                </div>
              ) : null}
              {userPrivateWheels?.length ? (
                <div ref={privateRef}>
                  <MainCard
                    isLoading={privateLoading}
                    deletingWheelId={isLoadingWheel}
                    wheelType={wheelTypes.private}
                    wheels={
                      searchedText.length
                        ? searchedPrivateWheels
                        : userPrivateWheels
                    }
                    mainImg={ASSETS.privateDark}
                    name={`Private`}
                    cardTitle={`Wheels`}
                    onDeleteWheelPress={onDeleteWheelPress}
                    isPrivate={true}
                    onMakePrimaryPress={onMakePrimaryPress}
                    onMakePublicPrivatePress={onMakePublicPrivatePress}
                  />
                </div>
              ) : null}
              {userClonedWheels?.length ? (
                <div ref={clonesRef}>
                  <MainCard
                    isLoading={clonedLoading}
                    deletingWheelId={isLoadingWheel}
                    wheelType={wheelTypes.clones}
                    wheels={
                      searchedText.length
                        ? searchedClonedWheels
                        : userClonedWheels
                    }
                    mainImg={ASSETS.publicDark}
                    name={`Cloned`}
                    cardTitle={`Wheels`}
                    onDeleteWheelPress={onDeleteWheelPress}
                    isPublic={true}
                    onMakePrimaryPress={onMakePrimaryPress}
                    onMakePublicPrivatePress={onMakePublicPrivatePress}
                  />
                </div>
              ) : null}

              {/* {filterWheels(UnlockWheels)?.length ? (
                    <div ref={unlockRef}>
                      <MainCard
                        deletingWheelId={isLoadingWheel}
                        wheelType={wheelTypes.unlock}
                        wheels={filterWheels(UnlockWheels)}
                        mainImg={ASSETS.unlockDark}
                        name={`Unlock`}
                        cardTitle={`Wheels`}
                        onDeleteWheelPress={onDeleteWheelPress}
                        onMakePrimaryPress={onMakePrimaryPress}
                      />
                    </div>
                  ) : null} */}
            </>
          )}
        </>
      )}
    </>
  );
};

export default WheelsSection;
